import React, {Fragment} from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {AvailableApps, rankList, traversePropertiesArray} from '../shared/shared';
import {getData} from "../../../api/doLogin";
import Select from 'react-select';
import '../../../../scss/vendors/react-select/react-select.scss';

export function BasicInfo(props) {
  const {values, handleCB, readonly, token} = props;

  function setFormFieldValue(field, value) {
    if (readonly) return;
    var objPost = {
      ...values,
      [field]: value,
    }
    handleCB(objPost);
  };

  function buildRank(branch) {
    let rankArray = rankList(branch) || [];
    return rankArray.map((value, index) => {
      return (
        <option key={index + 1} value={value}>{value}</option>
      );
    });
  }

  function getFormFieldValue(val) {
    if (val != null) {
      return val;
    } else {
      return "";
    }
  };

  function fetchZipDetails(zip, city, state) {
    if (readonly) return;
    if (zip.length === 0) {
      var objPost = {
        ...values,
        [city]: "",
        [state]: ""
      }
      handleCB(objPost);
      return;
    }
    getData("zip/get?zip=" + zip, {}, token)
      .then((data) => {
        if (data.status == "Success") {
          console.log(data.data);
          if (data.data.zipDetails.hasOwnProperty("city") && data.data.zipDetails.hasOwnProperty("state")) {
            var objPost = {
              ...values,
              [city]: data.data.zipDetails.city,
              [state]: data.data.zipDetails.state
            }
            handleCB(objPost);
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };
  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h2>Basic Information</h2>
        </Col>
      </Row>
      <Row>
        <Col xs={"6"}>
          <FormGroup>
            <Label htmlFor="selectedApps">Chosen&nbsp;Applications*</Label>
            <Select
              id="selectedApps"
              name="selectedApps"
              value={traversePropertiesArray(values, ["selectedApps"])}
              options={AvailableApps}
              onChange={(selectedApps) => setFormFieldValue("selectedApps", selectedApps.map(r => r.value))}
              multi
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={2}>
          <FormGroup>
            <Label htmlFor="relationshipStatus">Marital&nbsp;Status*</Label>
            <Input type="select" name="relationshipStatus" id="relationshipStatus"
                   value={getFormFieldValue(values.relationshipStatus)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              <option key={1} value={"S"}>Single</option>
              <option key={2} value={"M"}>Married</option>
              <option key={3} value={"W"}>Widowed</option>
              <option key={4} value={"D"}>Divorced</option>
            </Input>
          </FormGroup>
        </Col>
        <Col xs={12} md={3}>
          <FormGroup>
            <Label htmlFor="memberStatus">Coverage&nbsp;Status*</Label>
            <Input type="select" name="memberStatus" id="memberStatus"
                   value={getFormFieldValue(values.memberStatus)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              <option key={1} value={"N"}>New Member</option>
              <option key={2} value={"A"}>Request Additional Insurance</option>
              <option key={3} value={"C"}>Request Change in Coverage</option>
              {(getFormFieldValue(values.relationshipStatus) === "M") && (
                <option key={4} value={"ZZ"}>Spouse Only</option>
              )}

            </Input>
          </FormGroup>
        </Col>
        {(getFormFieldValue(values.relationshipStatus) === "M") && (
          <Fragment>
            <Col xs={12} md={3}>
              <FormGroup>
                <Label htmlFor="spcstatus">Spouse&nbsp;Coverage&nbsp;Status*</Label>
                <Input type="select" name="spcstatus" id="spcstatus"
                       value={getFormFieldValue(values.spcstatus)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                  <option key={0} value={""} disabled={true}>Choose</option>
                  <option key={1} value={"N"}>New Member</option>
                  <option key={2} value={"A"}>Request Additional Insurance</option>
                  <option key={3} value={"C"}>Request Change in Coverage</option>
                  <option key={4} value={"ZZ"}>Primary Only</option>
                </Input>
              </FormGroup>
            </Col>
            <Col xs={12} md={2}>
              <FormGroup>
                <Label htmlFor="milmembers">Military&nbsp;Members*</Label>
                <Input type="select" name="milmembers" id="milmembers"
                       value={getFormFieldValue(values.milmembers)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                  <option key={0} value={""} disabled={true}>Choose</option>
                  <option key={1} value={"1"}>Just One</option>
                  <option key={2} value={"2"}>Both</option>
                </Input>
              </FormGroup>
            </Col>
          </Fragment>
        )}
      </Row>

      <br/>


    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/BasicInfo.js